<template>
	<div class="d-flex j-center">
		<div class="content-box">
			<div style="font-size: 14px;font-weight: 600;margin-top: 61px;">
				商品订单：{{order_sn}}
			</div>
			<div style="font-size: 14px;font-weight: 600;margin-top: 31px;">
				支付金额：<span style="color: #00C066;font-size: 20px;">￥</span><span style="color: #00C066;font-size: 28px;">2580</span>
			</div>
			<div style="border-bottom: 1px dashed #3333333;width: 607px;margin-top: 11px;"></div>
			<div style="font-size: 14px;font-weight: 600;margin-top: 31px;">
				支付方式：
			</div>
			<div class="d-flex" style="margin-top: 22px;">
				<div @click="curIndex=1" class="d-flex a-center j-center"
				style="width: 180px;height: 50px;border-radius: 4px;box-sizing:
				border-box;cursor: pointer;position: relative;" :class="curIndex == 1 ?'active':'nactive'">
					<div class="d-flex a-center j-center">
						<img style="width: 30px;height: 30px;" src="../../assets/brand_fixtures/wxzf.png"/>
						<div style="font-size: 14px;font-weight: 600;margin-left: 8px;">微信支付</div>
					</div>
					<img v-if="curIndex==1" style="width: 32px;height: 28px;position: absolute;bottom:0;right: 0;" src="../../assets/brand_fixtures/ng.png" />
				</div>
				<div @click="fcib_get_product_alipay" class="d-flex a-center j-center"
				style="margin-left:21px;width: 180px;height: 50px;border-radius: 4px;
				box-sizing:border-box;cursor: pointer;position: relative;" :class="curIndex == 2 ?'active':'nactive'">
					<div class="d-flex a-center j-center">
						<img style="width: 30px;height: 30px;" src="../../assets/brand_fixtures/zfbzf.png"/>
						<div style="font-size: 14px;font-weight: 600;margin-left: 8px;">支付宝支付</div>
					</div>
					<img v-if="curIndex==2" style="width: 32px;height: 28px;position: absolute;bottom:0;right: 0;" src="../../assets/brand_fixtures/ng.png" />
				</div>
			</div>
			<div v-if="curIndex==1" style="margin-top: 30px;">
				<img style="width: 194px;height: 194px;" :src="qrcode" />
				<div style="width: 194px;height: 39px;background: #09BB07;border-radius: 4px; font-size:12px;color:#ffffff;" 
				class="d-flex j-center a-center">
					请打开手机微信，扫一扫完成支付
				</div>
			</div>
			<div @click="$router.back()" class="d-flex a-center j-center"
			style="margin-top:27px;width: 150px;height: 36px;background: #1E69FF;border-radius: 4px;font-size:16px;color:#ffffff">
				取消订单
			</div>
		</div>
	</div>
	
</template>

<script>
	export default{
		data(){
			return{
				curIndex:1,
				qrcode:'',
				order_id:'',
				order_sn:'',
				time:''
			}
		},
		created() {
			this.fcib_home_page_tpl_create()
		},
		mounted() {
			this.time = setInterval(()=>{
				this.fcib_order_info()
			},1500)
		},
		destroyed() {
			clearInterval(this.time)
		},
		methods:{
			fcib_home_page_tpl_create(){
				let params = {
					act:'co_pe_order_create',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					money_paid: 0.01
				}	
				this.$api.fcib_home_page_tpl_create(params).then((res)=>{
					if(res.code == 0){
						this.order_id = res.data.order_id
						this.order_sn = res.data.order_sn
						this.fcib_get_product_wxpay(res.data.order_id)
					}
				})
			},
			fcib_get_product_wxpay(order_id){
				let params = {
					act:'fcib_get_product_wxpay',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					order_id: order_id
				}	
				this.$api.fcib_home_page_tpl_create(params).then((res)=>{
					if(res.code == 0){
						this.qrcode = res.data.qrcode
					}
				})
			},
			fcib_get_product_alipay(){
				this.curIndex = 2
				let params = {
					act:'fcib_get_product_alipay',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					order_id: this.order_id
				}	
				this.$api.fcib_home_page_tpl_create(params).then((res)=>{
					if(res.code == 0){
						window.open(res.data.pay_url)
					}
				})
			},
			fcib_order_info(){
				let params = {
					act:'fcib_order_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					order_id: this.order_id
				}	
				this.$api.fcib_home_page_tpl_create(params).then((res)=>{
					if(res.code == 0){
						if(res.data.order_status == 1){
							this.$message({
								showClose: false,
								message: '支付成功',
								type: 'success',
								offset: 350
							})
							setTimeout(()=>{
								this.$router.back()
							},2000)
							
						}
					}
				})
			}
		}
	}
</script>

<style scoped>
	.content-box{
		width: 1170px;
		min-height: 960px;
		background: #FFFFFF;
		border-radius: 6px;
		flex-wrap: wrap;
		padding-left: 329px;
		box-sizing: border-box;
	}
	.nactive{
		border: 2px solid #BBBBBB;
	}
	.active{
		border: 2px solid #1E69FF;
	}
</style>